export default __webpack_public_path__ + "static/nextgen-a598a5fd9a51cc50b086b2ab61e85a7d.svg";